export default "__VITE_ASSET__CHVSmB44__"